import React from 'react';
import { Grid, Checkbox, FormControlLabel, Typography, TextField, FormGroup } from '@mui/material';


interface ApresentacaoState {
    identificacaoProductoApresentacaoProductoA: boolean;
    identificacaoProductoApresentacaoProductoB: boolean;
    identificacaoProductoApresentacaoProductoC: boolean;
    identificacaoProductoApresentacaoProductoD: boolean;
    identificacaoProductoApresentacaoProductoE: boolean;
    identificacaoProductoApresentacaoProductoF: boolean;
    identificacaoProductoApresentacaoProductoG: boolean;
    identificacaoProductoApresentacaoProductoH: boolean;
    identificacaoProductoApresentacaoProductoI: boolean;
    identificacaoProductoApresentacaoProductoJ: boolean;
    identificacaoProductoApresentacaoProductoK: boolean;
    identificacaoProductoApresentacaoProductoOutros: string;
    identificacaoProductoDefeitosA: boolean;
    identificacaoProductoDefeitosB: boolean;
    identificacaoProductoDefeitosC: boolean;
    identificacaoProductoDefeitosD: boolean;
    identificacaoProductoDefeitosE: boolean;
    identificacaoProductoDefeitosF: boolean;
    identificacaoProductoDefeitosG: boolean;
    identificacaoProductoDefeitosH: boolean;
    identificacaoProductoDefeitosI: boolean;
    identificacaoProductoDefeitosOutros: string;
}

interface ProdutoDefeitosProps {
    apresentacaoState: ApresentacaoState;
    handleCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleOutrosChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ProdutoDefeitos: React.FC<ProdutoDefeitosProps> = ({
    apresentacaoState,
    handleCheckboxChange,
    handleOutrosChange
}) => {


    // const [apresentacaoState, setApresentacaoState] = useState({
    //     identificacaoProductoApresentacaoProductoA: false,
    //     identificacaoProductoApresentacaoProductoB: false,
    //     identificacaoProductoApresentacaoProductoC: false,
    //     identificacaoProductoApresentacaoProductoD: false,
    //     identificacaoProductoApresentacaoProductoE: false,
    //     identificacaoProductoApresentacaoProductoF: false,
    //     identificacaoProductoApresentacaoProductoG: false,
    //     identificacaoProductoApresentacaoProductoH: false,
    //     identificacaoProductoApresentacaoProductoI: false,
    //     identificacaoProductoApresentacaoProductoJ: false,
    //     identificacaoProductoApresentacaoProductoK: false,
    //     identificacaoProductoApresentacaoProductoOutros: '',
    //     identificacaoProductoDefeitosA: false,
    //     identificacaoProductoDefeitosB: false,
    //     identificacaoProductoDefeitosC: false,
    //     identificacaoProductoDefeitosD: false,
    //     identificacaoProductoDefeitosE: false,
    //     identificacaoProductoDefeitosF: false,
    //     identificacaoProductoDefeitosG: false,
    //     identificacaoProductoDefeitosH: false,
    //     identificacaoProductoDefeitosI: false,
    //     identificacaoProductoDefeitosOutros: ''
    // });

    // const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const { name, checked } = event.target;
    //     setApresentacaoState(prev => ({ ...prev, [name]: checked }));
    // };

    // const handleOutrosChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setApresentacaoState(prev => ({
    //         ...prev,
    //         identificacaoProductoApresentacaoProductoOutros: event.target.value
    //     }));
    // };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant="subtitle1" fontWeight={600}>
                    Apresentação do Produto (seleção múltipla)
                </Typography>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoApresentacaoProductoA"
                                checked={apresentacaoState.identificacaoProductoApresentacaoProductoA}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Comprimidos/cápsulas orais"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoApresentacaoProductoB"
                                checked={apresentacaoState.identificacaoProductoApresentacaoProductoB}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Suspensão, xaropes"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoApresentacaoProductoC"
                                checked={apresentacaoState.identificacaoProductoApresentacaoProductoC}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Injecção"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoApresentacaoProductoD"
                                checked={apresentacaoState.identificacaoProductoApresentacaoProductoD}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Diluente"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoApresentacaoProductoE"
                                checked={apresentacaoState.identificacaoProductoApresentacaoProductoE}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Pó para reconstituição da suspensão"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoApresentacaoProductoF"
                                checked={apresentacaoState.identificacaoProductoApresentacaoProductoF}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Pó para reconstituição de injectáveis"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoApresentacaoProductoG"
                                checked={apresentacaoState.identificacaoProductoApresentacaoProductoG}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Gotas oftálmicas"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoApresentacaoProductoH"
                                checked={apresentacaoState.identificacaoProductoApresentacaoProductoH}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Gotas nasais"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoApresentacaoProductoI"
                                checked={apresentacaoState.identificacaoProductoApresentacaoProductoI}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Gotas auriculares"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoApresentacaoProductoJ"
                                checked={apresentacaoState.identificacaoProductoApresentacaoProductoJ}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Nebulizadores"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoApresentacaoProductoK"
                                checked={apresentacaoState.identificacaoProductoApresentacaoProductoK}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Cremes, pomadas, pastas, linimentos"
                    />
                    <TextField
                        label="Outros (especifique)"
                        name="identificacaoProductoApresentacaoProductoOutros"
                        multiline
                        fullWidth
                        size="small"
                        value={apresentacaoState.identificacaoProductoApresentacaoProductoOutros}
                        onChange={handleOutrosChange}
                        sx={{ mt: 1 }}
                    />
                </FormGroup>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="subtitle1" fontWeight={600}>
                    Defeitos (seleção múltipla)
                </Typography>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoDefeitosA"
                                checked={apresentacaoState.identificacaoProductoDefeitosA}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Separação"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoDefeitosB"
                                checked={apresentacaoState.identificacaoProductoDefeitosB}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Solidificação/(endurece)"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoDefeitosC"
                                checked={apresentacaoState.identificacaoProductoDefeitosC}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Esfarelamento"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoDefeitosD"
                                checked={apresentacaoState.identificacaoProductoDefeitosD}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Moldura defeituosa"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoDefeitosE"
                                checked={apresentacaoState.identificacaoProductoDefeitosE}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Mudança de Cheiro"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoDefeitosF"
                                checked={apresentacaoState.identificacaoProductoDefeitosF}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Mudança de cor"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoDefeitosG"
                                checked={apresentacaoState.identificacaoProductoDefeitosG}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Rotulagem defeituoso"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoDefeitosH"
                                checked={apresentacaoState.identificacaoProductoDefeitosH}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Acondicionamento defeituoso"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="identificacaoProductoDefeitosI"
                                checked={apresentacaoState.identificacaoProductoDefeitosI}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Rotulagem e prospecto deficiente"
                    />

                    <TextField
                        label="Outros (especifique)"
                        name="identificacaoProductoDefeitosOutros"
                        multiline
                        fullWidth
                        size="small"
                        value={apresentacaoState.identificacaoProductoDefeitosOutros}
                        onChange={handleOutrosChange}
                        sx={{ mt: 1 }}
                    />
                </FormGroup>
            </Grid>
        </Grid>
    )
}

export default ProdutoDefeitos
